import consumer from "./consumer"

/**
 * Creates a LiveReportingChannel subscription for a given survey.
 * Handles ActionCable events for live reporting, including pause/resume.
 * @param {number|string} surveyId - The survey ID to subscribe to
 * @param {Object} callbacks - Optional callbacks for received, paused, resumed events
 * @param {function} [callbacks.received] - Called when a broadcast is received
 * @param {function} [callbacks.paused] - Called when pause is acknowledged
 * @param {function} [callbacks.resumed] - Called when resume is acknowledged
 * @returns {Object} The ActionCable subscription
 */
export default function createLiveReportingChannel(surveyId, callbacks = {}) {
  return consumer.subscriptions.create(
    { channel: "LiveReportingChannel", survey_id: surveyId },
    {
      /**
       * Called when a broadcast is received from the server.
       * Passes data to the provided callback if present.
       * @param {Object} data - The broadcast data
       */
      received(data) {
        console.log('Received live reporting broadcast:', data);
        if (callbacks.received) {
          callbacks.received(data);
        }
      },

      /**
       * Sends a pause command to the server and notifies callback.
       * @param {number} position - The position to pause at
       * @param {boolean} manual - Whether this is a manual pause (true) or navigation pause (false)
       */
      pause(position, manual = false) {
        console.log('Pausing live reporting at position:', position, 'manual:', manual);
        this.perform('pause', { survey_id: surveyId, position, manual });
        if (callbacks.paused) {
          callbacks.paused(position);
        }
      },

      /**
       * Sends a resume command to the server and notifies callback.
       */
      resume() {
        console.log('Resuming live reporting');
        this.perform('resume', { survey_id: surveyId });
        if (callbacks.resumed) {
          callbacks.resumed();
        }
      }
    }
  );
}
